module.exports = __webpack_public_path__ + "assets/js/wasm/recast-cdfd36cc3c82e78bb3b253ec10d6b9b4.wasm";